"use client";

import { useSyncExternalStore } from "react";
import { DatadogAppRouter } from "@datadog/browser-rum-nextjs";
// From datadogRumReady, not instrumentation-client: importing a value from the latter pulls that
// client-only entrypoint into this component's server bundle, where it throws on `window`.
import { DATADOG_RUM_READY_EVENT } from "@/datadogRumReady";

function subscribe(callback: () => void): () => void {
  window.addEventListener(DATADOG_RUM_READY_EVENT, callback);
  return () => window.removeEventListener(DATADOG_RUM_READY_EVENT, callback);
}

function getSnapshot(): boolean {
  return window.__datadogRumReady === true;
}

function getServerSnapshot(): boolean {
  return false;
}

/**
 * DatadogAppRouter starts tracking a view on its very first render. If that render happens
 * before datadogRum.init() has finished (init is behind an async dynamic import), the call
 * silently no-ops with no retry, permanently losing the first view of a cold page load. This
 * wrapper delays mounting DatadogAppRouter until instrumentation-client.ts signals it's done.
 * useSyncExternalStore (rather than an effect + setState) avoids the render/subscribe race.
 */
export function DatadogRumRouter() {
  const ready = useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);

  if (!ready) {
    return null;
  }

  return <DatadogAppRouter />;
}
